export default __webpack_public_path__ + "static/media/diving-board.12c2120e.svg";